import { Component, OnInit, ViewChild } from '@angular/core';
import { Global } from '../../global'
import { AppComponent } from '../../app.component';
import { CommonService } from '../../services/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { configObj } from '../../configuration';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {


  public configuration = configObj;
  constructor(
    public global: Global,
    public app: AppComponent,
    public commonServices: CommonService, private modalService: NgbModal,
    private ngxService: NgxUiLoaderService,
    public appComp:AppComponent,
    private toastr: ToastrService,
    private router:Router
  ) { }

  @ViewChild('logoutConfirmation') logoutConfirmation: any;

  ngOnInit(): void {
  }

  private logoutRef
  clickTrack(label,action){
    this.commonServices.trackUser(label,action,null)
  }

  openLogoutPopup(){
    this.commonServices.saveAllChange()
    this.logoutRef = this.modalService.open(this.logoutConfirmation , { centered: true ,windowClass:"logoutModal" , backdrop:'static'});
  }

  //logout user
  logoutUser(value){
    this.logoutRef.close()
    this.ngxService.start()
    if(value == "Yes"){
      this.commonServices.logoutUser()
      this.modalService.dismissAll();
      // setTimeout(() => {
      //   this.router.navigate(['login'])
      // }, 10);
    }
    else{
      this.ngxService.stop()
    }
  }


  //request for token id on logout
  saveSetupOnLogout(){
    this.commonServices.createDataWithUpdatedValues()
    this.ngxService.start()
    this.commonServices.getApiToken("CARD_LIMIT_FLAG").subscribe(
      res => {
        // this.ngxService.stop()
        if(res && res['id']){
          this.sendUpdatedDataOnLogout(res['id'])
        }
        else{
          this.callLogout()
        }
      },
      err => {
        this.ngxService.stop()
        this.callLogout()
      }
    )
  }

  //save changes on logout
  sendUpdatedDataOnLogout(tokenid){
    this.ngxService.start()
    this.clickTrack('updateDashboardData','click')
    this.commonServices.updateDashboardData(tokenid,this.commonServices.dashboardActualData,'logoutPopup').subscribe(
      res=>{
        this.ngxService.stop()
        this.appComp.closeModal()
        if(res && res['rewardResponse']){
          this.commonServices.userInfo['rewardResponse'] = res['rewardResponse']
        }
        this.appComp.openSetupSucessful('dashboardSetup',res?.['showSucessPage'] ? true : false,'saveAndLogout')
        setTimeout(() => {
          this.logoutUser('Yes')
        }, 2000);
      },
      err=>{
        this.ngxService.stop()
        this.callLogout()
      }
    )
  }
  

  callLogout(){
    this.toastr.error("Something went wrong, please try again later!")
    setTimeout(() => {
      this.logoutUser('Yes')
    }, 2000);
  }




}
